import { PropsWithChildren } from "react";

import { FilterBar, Item } from "@bps/fluent-ui";

export interface SoftwareSearchTableFilterValues {
  name: string;
}

interface SoftwareSearchTableFilterProps extends PropsWithChildren<any> {
  setFilterArgs: React.Dispatch<
    React.SetStateAction<SoftwareSearchTableFilterValues | undefined>
  >;
}

export const SoftwareSearchTableFilter = ({
  children,
  setFilterArgs
}: SoftwareSearchTableFilterProps) => {
  const filterItems: Item<SoftwareSearchTableFilterValues>[] = [
    {
      name: "name",
      type: "searchBox",
      stickItem: true,
      props: {
        placeholder: "Search by name",
        removeSpecialCharacters: false
      }
    }
  ];

  return (
    <FilterBar<SoftwareSearchTableFilterValues>
      items={filterItems}
      initialValues={{
        name: ""
      }}
      onChange={filter => setFilterArgs({ name: filter.state.values.name })}
    >
      {children}
    </FilterBar>
  );
};
